import template from "./bagouts.html";
import controller from "./bagouts.controller";
import "./bagouts.scss";

let branchManagementBagoutsComponent = {
  restrict: "E",
  bindings: {},
  template,
  controller
};

export default branchManagementBagoutsComponent;


// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/bagouts/bagouts.component.js